import {hideDialog, isnull, Toast, Uint8ArrayToString, wrapVal} from '../utils/tools'
import {log, loge} from '../utils/devext'
import global from '../config/global'
import aes from '../utils/aes'
import {Queue} from '../utils/SetUtils'

export const BlurCMD = {
  CMD_OPEN_BLUR: '1',
  CMD_CANCEL_BLUR: '0'
}
export const RTCMsgType = {
  SELF: 0,
  REMOTE: 1
}
export const RoomType = {
  O2O: 1,//1对1私聊
  O2M: 2,//1对多
  M2M: 3,//多对多聊天室
}

export const ClientRole = {
  CLIENT_ROLE_BROADCASTER: 'host',
  CLIENT_ROLE_AUDIENCE: 'audience'
}

export const ChannelProfile = {
  CHANNEL_PROFILE_COMMUNICATION: 0,
  CHANNEL_PROFILE_LIVE_BROADCASTING: 1,
  CHANNEL_PROFILE_GAME: 2
}

export const AudioProfile = {
  DEFAULT: 0,
  SPEECH_STANDARD: 1,
  MUSIC_STANDARD: 2,
  MUSIC_STANDARD_STEREO: 3,
  MUSIC_HIGH_QUALITY: 4,
  MUSIC_HIGH_QUALITY_STEREO: 5
}

export const AudioScenario = {
  DEFAULT: 0,
  CHATROOM_ENTERTAINMENT: 1,
  EDUCATION: 2,
  GAME_STREAMING: 3,
  SHOWROOM: 4,
  CHATROOM_GAMING: 5,
  IOT: 6,
  MEETING: 8
}

export const RemoteAudioState = {
  REMOTE_AUDIO_STATE_STOPPED: 0,
  REMOTE_AUDIO_STATE_STARTING: 1,
  REMOTE_AUDIO_STATE_DECODING: 2,
  REMOTE_AUDIO_STATE_FROZEN: 3,
  REMOTE_AUDIO_STATE_FAILED: 4
}

export const RemoteAudioReason = {
  REMOTE_AUDIO_REASON_INTERNAL: 0,
  REMOTE_AUDIO_REASON_NETWORK_CONGESTION: 1,
  REMOTE_AUDIO_REASON_NETWORK_RECOVERY: 2,
  REMOTE_AUDIO_REASON_LOCAL_MUTED: 3,
  REMOTE_AUDIO_REASON_LOCAL_UNMUTED: 4,
  REMOTE_AUDIO_REASON_REMOTE_MUTED: 5,
  REMOTE_AUDIO_REASON_REMOTE_UNMUTED: 6,
  REMOTE_AUDIO_REASON_REMOTE_OFFLINE: 7
}

export const RemoteVideoState = {
  REMOTE_VIDEO_STATE_STOPPED: 0,
  REMOTE_VIDEO_STATE_STARTING: 1,
  REMOTE_VIDEO_STATE_DECODING: 2,
  REMOTE_VIDEO_STATE_FROZEN: 3,
  REMOTE_VIDEO_STATE_FAILED: 4,
}

export const RemoteVideoReason = {
  REMOTE_VIDEO_STATE_REASON_INTERNAL: 0,
  REMOTE_VIDEO_STATE_REASON_NETWORK_CONGESTION: 1,
  REMOTE_VIDEO_STATE_REASON_NETWORK_RECOVERY: 2,
  REMOTE_VIDEO_STATE_REASON_LOCAL_MUTED: 3,
  REMOTE_VIDEO_STATE_REASON_LOCAL_UNMUTED: 4,
  REMOTE_VIDEO_STATE_REASON_REMOTE_MUTED: 5,
  REMOTE_VIDEO_STATE_REASON_REMOTE_UNMUTED: 6,
  REMOTE_VIDEO_STATE_REASON_REMOTE_OFFLINE: 7,
  REMOTE_VIDEO_STATE_REASON_AUDIO_FALLBACK: 8,
  REMOTE_VIDEO_STATE_REASON_AUDIO_FALLBACK_RECOVERY: 9,
}

export default class TopRtcDelegate {
  cName = 'TopRtcDelegate'
  /**
   * 当前房间号
   */
  channelName = null

  // /**
  //  * 当前房间类型
  //  */
  // roomType = RoomType.O2O

  /**
   * 声网音视频引擎
   * rtcEngine
   */
  mRtcClient = null

  /**
   * 每个视频分辨率
   * VideoEncoderConfiguration.VideoDimensions
   */
  dimensions = null

  /**
   * 每个视频码率
   * VideoEncoderConfiguration.FRAME_RATE
   */
  frameRate = null

  /**
   * 每个视频帧率
   */
  bitrate = null

  /**
   * 是否切换到后置摄像头
   */
  hasToggleBackCamera = false

  /**
   * 是否关闭本地摄像头
   */
  hasMuteLocalCamera = false

  /**
   * 是否关闭本地麦克风
   */
  hasMuteLocalMic = false

  /**
   * 声网模块和ui页面的桥梁，事件回调
   * RtcEventHandler
   */
  eventHandler = null

  /**
   * 加载视屏的所有容器，用于在释放资源的时候清空容器
   * ArrayList<WeakReference<ViewGroup>>()
   */
  videoContainerListRef = []

  remoteUsers = {}

  localTracks = {
    videoTrack: null,
    audioTrack: null
  }
  localDevices = {
    audioDevices: null,
    videoDevices: null,
    videoDeviceIndex: 0
  }

  hasJoined = false

  options = {
    appid: null,
    channel: null,
    uid: null,
    token: null,
    audienceLatency: ClientRole.CLIENT_ROLE_BROADCASTER
  }

  videoProfiles = [
    {label: '480p_1', detail: '640×480, 15fps, 500Kbps', value: '480p_1'},
    {label: '480p_2', detail: '640×480, 30fps, 1000Kbps', value: '480p_2'},
    {label: '720p_1', detail: '1280×720, 15fps, 1130Kbps', value: '720p_1'},
    {label: '720p_2', detail: '1280×720, 30fps, 2000Kbps', value: '720p_2'},
    {label: '1080p_1', detail: '1920×1080, 15fps, 2080Kbps', value: '1080p_1'},
    {label: '1080p_2', detail: '1920×1080, 30fps, 3000Kbps', value: '1080p_2'},
    {label: '200×640', detail: '200×640, 30fps', value: {width: 200, height: 640, frameRate: 30}} // custom video profile
  ]

  curVideoProfile = this.videoProfiles[0]

  pageTarget = null
  pendingTasks = new Map()
  page$ = null

  userId = ''
  hasPublishVideo = false
  hasPublishAudio = false

  encoderCfg = null

  //房间类型
  constructor(type) {
    this.roomType = type
  }

  /**
   * 加入房间
   * @param channelName   房间号
   * @param userId        用户id
   * @return              加入房间是否成功
   */
  async joinChannel(channelName, userId, vuePage, role, $, publishInit = true, cameraOn = true, micOn = true) {
    this.options.appid = aes.decrypt(vuePage.$globalAppCfg.agoapp)
    this.options.channel = channelName
    this.options.uid = Number(userId)
    this.pageTarget = vuePage
    this.page$ = $
    this.userId = userId
    this.encoderCfg = vuePage.page == 'MB_ROOM' ? {
      frameRate: 15,
      height: 320,
      width: 240
    } : {
      frameRate: 24,
      height: 480,
      width: 840
    }
    if (this.mRtcClient == null) {
      this.buildRtcEngine()
    }
    // this.buildRtcVideoProfile()
    // if (role == ClientRole.CLIENT_ROLE_BROADCASTER)
    //   this.setBroadcast()
    // else
    //   this.setAudience()
    this.setBroadcast()
    let ret = -1
    let target = this
    if (this.mRtcClient) {
      this.mRtcClient.on('user-published', function (user, mediaType) {
        target.handleUserPublished(user, mediaType, target, $)
      })
      this.mRtcClient.on('user-unpublished', function (user, mediaType) {
        target.handleUserUnpublished(user, target, mediaType)
      })
      this.mRtcClient.on('user-info-updated', function (uid, msgState) {
        if (['mute-audio', 'unmute-audio'].indexOf(msgState) != -1) {
          target.notifyAudioMuteChange(uid, msgState == 'mute-audio')
        }
        if (['mute-video', 'unmute-video'].indexOf(msgState) != -1) {
          target.notifyVideoMuteChange(uid, msgState == 'mute-video')
        }
      })
      this.mRtcClient.on('user-joined', this.eventHandler.onUserJoined)
      this.mRtcClient.on('user-offline', this.eventHandler.onUserOffline)
      this.mRtcClient.on('user-left', this.eventHandler.onUserLefted)
      this.mRtcClient.on('connection-state-change', this.eventHandler.onConnectionStateChanged)
      this.mRtcClient.on('stream-message', function (uid, data) {
        target.onStreamMessage(uid, data, target)
      })
      if (!this.hasJoined) {
        this.options.uid = await this.mRtcClient.join(this.options.appid, this.options.channel, this.options.token || null, this.options.uid || null).then(() => {
          target.onJoinChannelSuccess(channelName, userId)
          target.setJoined()
          setTimeout(function () {
            target.pendingTasks.forEach((value, key) => {
              value && value()
            })
            target.pendingTasks.clear()
          }, 600)

        }).catch(e => {
          loge('RTC-JOIN-ROOM', e)
        })
        if (publishInit) {
          this.publishLocal($, vuePage, userId, cameraOn, micOn)
        }
      }
    }
    return ret == 0
  }

  notifyVideoMuteChange(uid, isMute) {
    if (this.eventHandler) {
      if (uid == this.options.uid) {
        this.eventHandler.onLocalVideoMuteChange(isMute, uid)
      } else {
        this.eventHandler.onRemoteVideoMuteChange(uid, isMute)
      }
    }
  }

  notifyAudioMuteChange(uid, isMute) {
    if (this.eventHandler) {
      if (uid == this.options.uid) {
        this.eventHandler.onLocalAudioMuteChange(isMute, uid)
      } else {
        this.eventHandler.onRemoteAudioMuteChange(uid, isMute)
      }
    }
  }

  publishLocal($, vuePage, userId, withCamera = true, withMic = true) {
    let target = this
    if (!this.hasJoined) {
      target.pendingTasks.set('publishLocal', function () {
        target.publishLocal($, vuePage, userId, withCamera, withMic)
      })
      return
    }
    this.unpublishLocal(true)
    AgoraRTC.getDevices().then(async devices => {
      let audioDevices = []
      if (withMic) {
        devices.filter(function (device) {
          return device.kind === 'audioinput'
        })
        if (isnull(audioDevices)) {
          audioDevices = await AgoraRTC.getMicrophones().then(audios => {
            return audios
          })
        }
      }
      let videoDevices = []
      if (withCamera) {
        videoDevices = devices.filter(function (device) {
          return device.kind === 'videoinput'
        })
        if (isnull(videoDevices)) {
          videoDevices = await AgoraRTC.getCameras().then(cameraDevices => {
            return cameraDevices
          })
        }
      }
      if (withMic && isnull(audioDevices) && withCamera && isnull(videoDevices)) {
        Toast.error('No camera and mic to communicate with this host.', vuePage)
        return false
      } else if (isnull(videoDevices) && withCamera) {
        vuePage && vuePage.putOffMic && vuePage.putOffMic.putOffMic()
        Toast.error('No camera device to display.', vuePage)
        return false
      } else if (isnull(audioDevices) && withMic) {
        vuePage && vuePage.putOffMic && vuePage.putOffMic.putOffMic()
        Toast.error('No audio device to display.', vuePage)
        return false
      }
      var selectedMicrophoneId = isnull(audioDevices) ? '' : audioDevices[0].deviceId
      var selectedCameraId = isnull(videoDevices) ? '' : videoDevices[0].deviceId
      return Promise.all([
        isnull(selectedCameraId) ? null : await AgoraRTC.createCameraVideoTrack({
          cameraId: selectedCameraId,
          encoderConfig: target.encoderCfg
        }),
        // isnull(selectedCameraId) ? null : await AgoraRTC.createCameraVideoTrack({facingMode:'user'}),
        isnull(selectedMicrophoneId) ? null : await AgoraRTC.createMicrophoneAudioTrack({microphoneId: selectedMicrophoneId}),
        audioDevices,
        videoDevices
      ])
    }).then(args => {
        if (!args) {
          console.log('device not support')
        } else {
          console.log('args:', args)
          target.localTracks.videoTrack = args[0]
          target.localTracks.audioTrack = args[1]
          target.localDevices.audioDevices = args[2]
          target.localDevices.videoDevices = args[3]
          target.filterVideoDevices()
          log('publish-local', target.localTracks)
          if (target.localTracks.videoTrack) {
            $('#player-' + userId).html('')
            target.localTracks.videoTrack.play('player-' + userId, {fit: 'cover'})
            let localVideoWidget = $('.sm-player div,.sm-player video')
            localVideoWidget.css({
              'border-radius': (24 / 75 * 1) + 'rem',
              'position': 'absolute !important'
            })
            document.getElementById('player-' + userId).firstElementChild.style.position = 'absolute'
            target.localTracks.videoTrack.on('video-element-visible-status', status => {
              if (target.eventHandler) {
                target.eventHandler.onLocalPushSuccess()
              }
            })
          }
          let tracks = Object.values(target.localTracks).filter(function (device) {
            return device != null
          })
          if (!isnull(tracks)) {
            target.mRtcClient.publish(tracks).then(() => {
              if (!isnull(target.localTracks.videoTrack))
                target.hasPublishVideo = true
              if (!isnull(target.localTracks.audioTrack))
                target.hasPublishAudio = true
              if (target.eventHandler) {
                target.eventHandler.onLocalPushSuccess()
              }
              console.log('publish success')
            }).catch(e => {
              console.log('publish-error: ' + JSON.stringify(e))
              if (e.code == 'CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS') {
                target.unpublishLocal(true, function () {
                  target.publishLocal($, vuePage, userId, withCamera, withMic)
                })
              } else if (e.code == 'INVALID_OPERATION' && e.message.indexOf('Can\'t publish stream, haven\'t joined yet!') != -1) {
                target.pendingTasks.set('publishLocal', function () {
                  target.publishLocal($, vuePage, userId, withCamera, withMic)
                })
              }
            })
          }
        }
      }
    ).catch(e => {
      if (e.code == 'NOT_SUPPORTED') {
        Toast.error('No camera and mic to communicate', vuePage)
      }
      console.log(JSON.stringify(e))
    })
  }

  async publishLocalVideo(successCallback = null) {
    let videoDevices = await AgoraRTC.getCameras().then(cameraDevices => {
      return cameraDevices
    })
    let selectedCameraId = isnull(videoDevices) ? '' : videoDevices[0].deviceId
    this.localDevices.videoDevices = videoDevices
    if (!isnull(selectedCameraId))
      this.localTracks.videoTrack = await AgoraRTC.createCameraVideoTrack({
        cameraId: selectedCameraId,
        encoderConfig: this.encoderCfg
      })
    if (this.localTracks.videoTrack) {
      this.page$('#player-' + this.userId).html('')
      this.localTracks.videoTrack.play('player-' + this.userId, {fit: 'cover'})
      let localVideoWidget = this.page$('.sm-player div,.sm-player video')
      localVideoWidget.css({
        'border-radius': (24 / 75 * 1) + 'rem',
        'position': 'absolute !important'
      })
      document.getElementById('player-' + this.userId).firstElementChild.style.position = 'absolute'
      this.localTracks.videoTrack.on('video-element-visible-status', status => {
        if (this.eventHandler) {
          this.eventHandler.onLocalPushSuccess()
        }
      })
    }
    let target = this
    target.mRtcClient.publish(target.localTracks.videoTrack).then(() => {
      if (target.eventHandler) {
        target.eventHandler.onLocalPushSuccess()
      }
      target.hasPublishVideo = true
      console.log('publish success')
      successCallback && successCallback()
    }).catch(e => {
      console.log('publish-error: ' + JSON.stringify(e))
      if (e.code == 'CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS') {
        target.unpublishLocal(true, function () {
          target.publishLocalVideo()
        })
      } else if (e.code == 'INVALID_OPERATION' && e.message.indexOf('Can\'t publish stream, haven\'t joined yet!') != -1) {
        target.pendingTasks.set('publishLocalVideo', function () {
          target.publishLocalVideo()
        })
      }
    })
  }

  async publishLocalAudio(successCallback = null) {
    let audioDevices = await AgoraRTC.getMicrophones().then(audios => {
      return audios
    })
    let selectedMicrophoneId = isnull(audioDevices) ? '' : audioDevices[0].deviceId
    this.localDevices.audioDevices = audioDevices
    if (!isnull(selectedMicrophoneId))
      this.localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack({microphoneId: selectedMicrophoneId})
    let target = this
    target.mRtcClient.publish(this.localTracks.audioTrack).then(() => {
      target.hasPublishAudio = true
      successCallback && successCallback()
    }).catch(e => {
      console.log('publish-error: ' + JSON.stringify(e))
      if (e.code == 'INVALID_OPERATION' && e.message.indexOf('Can\'t publish stream, haven\'t joined yet!') != -1) {
        target.pendingTasks.set('publishLocalAudio', function () {
          target.publishLocalAudio()
        })
      }
    })
  }

  unpublishLocal(internal = false, next = null) {
    if (this.mRtcClient == null) {
      this.buildRtcEngine()
    }
    let target = this
    this.mRtcClient && this.mRtcClient.unpublish().then(() => {
      console.log('unpublish success')
      next && next()
    }).catch(e => {

    })
    for (var trackName in target.localTracks) {
      var track = target.localTracks[trackName]
      if (track) {
        track.stop()
        track.close()
        target.localTracks[trackName] = undefined
      }
    }
    target.hasMuteLocalMic = false
    target.hasMuteLocalCamera = false
    target.hasPublishAudio = false
    target.hasPublishVideo = false
    if (!internal) {
      if (target.eventHandler) {
        target.eventHandler.onLocalUnPushSuccess && target.eventHandler.onLocalUnPushSuccess()
      }
    }

  }

  filterVideoDevices() {
    if (!isnull(this.localDevices.videoDevices) && this.localDevices.videoDevices.length > 1) {
      let videos = new Array()
      videos.push(this.localDevices.videoDevices[0])
      for (var i = 1; i < this.localDevices.videoDevices.length; i++) {
        let tmp = this.localDevices.videoDevices[i]
        let hasFront = this.localDevices.videoDevices[0].label.toLowerCase().indexOf('front') != -1 || this.localDevices.videoDevices[0].label.toLowerCase().indexOf('前置') != -1
        let target = hasFront ? 'back' : 'front'
        let target2 = hasFront ? '后置' : '前置'
        if (!isnull(tmp.label)) {
          if (tmp.label.toLowerCase().indexOf(target) != -1 || tmp.label.toLowerCase().indexOf(target2) != -1) {
            videos.push(tmp)
            break
          }
        } else {
          videos.push(tmp)
          break
        }
      }
      this.localDevices.videoDevices = videos
    }
  }

  setJoined() {
    this.hasJoined = true
  }

  onStreamMessage(uid, data, page) {
    let msg = Uint8ArrayToString(data)
    log(page.cName, 'onStreamMessage-- msg=' + msg)
    if (page.eventHandler) {
      log(page.cName,
        'onStreamMessage-- msg' + msg
      )
      if ([BlurCMD.CMD_OPEN_BLUR, BlurCMD.CMD_CANCEL_BLUR].indexOf(msg) == -1) {
        page.eventHandler.onReceiveMsg(uid, msg, RTCMsgType.REMOTE)
      } else {
      }
    }
  }

  /**
   * 实例化rtc，以及基础设置
   */
  buildRtcEngine() {
    try {// 实例化rtc对象
      this.mRtcClient = AgoraRTC.createClient({mode: 'live', codec: 'vp8'})
    } catch (e) {
      loge(this.cName, '实例化rtc对象 失败!!![' + e + ']')
    }
  }

  /**
   * 更具不同类型配置视频质量
   */
  buildRtcVideoProfile() {
    if (this.mRtcClient) {
      let engine = this.mRtcClient
      if (this.roomType == RoomType.O2O) {
        engine.setClientRole(ClientRole.CLIENT_ROLE_BROADCASTER)
        // engine.setChannelProfile(ChannelProfile.CHANNEL_PROFILE_LIVE_BROADCASTING)
        this.dimensions = wrapVal(this.dimensions, VideoEncoderConfiguration.VD_640x360)
        this.frameRate = wrapVal(this.frameRate, VideoEncoderConfiguration.FRAME_RATE.FRAME_RATE_FPS_15)
        this.bitrate = wrapVal(this.bitrate, 200)
      } else if (this.roomType == RoomType.M2M) {
        // 设置直播模式
        // engine.setChannelProfile(ChannelProfile.CHANNEL_PROFILE_LIVE_BROADCASTING)
        // 设置角色为观众
        engine.setClientRole(ClientRole.CLIENT_ROLE_AUDIENCE)
        this.dimensions = wrapVal(this.dimensions, VideoEncoderConfiguration.VD_320x240)
        this.frameRate = wrapVal(this.frameRate, VideoEncoderConfiguration.FRAME_RATE.FRAME_RATE_FPS_15)
        this.bitrate = wrapVal(this.bitrate, 200)
      } else {
        // 设置直播模式
        // engine.setChannelProfile(ChannelProfile.CHANNEL_PROFILE_LIVE_BROADCASTING)
        // 设置角色为观众
        engine.setClientRole(ClientRole.CLIENT_ROLE_AUDIENCE)
        this.dimensions = wrapVal(this.dimensions, VideoEncoderConfiguration.VD_640x360)
        this.frameRate = wrapVal(this.frameRate, VideoEncoderConfiguration.FRAME_RATE.FRAME_RATE_FPS_15)
        this.bitrate = wrapVal(this.bitrate, 400)
      }
    }
  }

  /**
   * 获取rtcEngine对象
   * @param funName
   */
  requireRtcEngine(funName) {
    if (this.mRtcClient == null) {
      loge(this.cName, funName + '  mRtcClient is null!!!')
      this.buildRtcEngine()
    }
    return this.mRtcClient
  }

  /******************************* 以下是操作engine的方法 ****************************/

  /**
   * 停止接收所有远端视频流
   */
  pauseAllRemoteVideoStream() {
    let ref = this.requireRtcEngine('pauseAllRemoveVideoSteam')
    if (ref) {
      let ret = muteAllRemoteVideoStreams(true)
      log(this.cName, '停止接收所有的视频流  ' + ret)
    }

  }

  /**
   * 恢复接收所有远端视频流
   */
  resumeAllRemoteVideoStream() {
    let ref = this.requireRtcEngine('resumeAllRemoteVideoStream')
    if (ref) {
      let ret = muteAllRemoteVideoStreams(false)
      log(this.cName, '停止接收所有的视频流  ' + ret)
    }
  }

  /**
   * 停止接收所有远端音频流
   */
  pauseAllRemoteAudioStream() {
    let ref = this.requireRtcEngine('pauseAllRemoteAudioStream')
    if (ref) {
      let ret = muteAllRemoteVideoStreams(true)
      log(this.cName, '停止接收所有的视频流  ' + ret)
    }
  }

  /**
   * 恢复接收所有远端音频流
   */
  resumeAllRemoteAudioStream() {
    let ref = this.requireRtcEngine('resumeAllRemoteAudioStream')
    if (ref) {
      let ret = muteAllRemoteVideoStreams(false)
      log(this.cName, '恢复接收所有远端音频流  ' + ret)
    }
  }

  /**
   * 切换摄像头
   */
  async toggleCamera() {
    let ref = this.requireRtcEngine('toggleCamera')
    if (ref && !isnull(this.localTracks.videoTrack) && !isnull(this.localDevices.videoDevices) && this.localDevices.videoDevices.length > 1) {
      let videoDevice = this.localDevices.videoDevices[++this.localDevices.videoDeviceIndex % this.localDevices.videoDevices.length]
      let ret = this.localTracks.videoTrack.setDevice(videoDevice.deviceId)
      // await AgoraRTC.createCameraVideoTrack({cameraId: selectedCameraId})
      log(this.cName, '切换摄像头  ' + ret + '[label:' + videoDevice.label + ']')
      if (!ret) {
        this.hasToggleBackCamera = !this.hasToggleBackCamera
      }
      setTimeout(function () {
        let widget = document.getElementById('player-' + global.getUserId())
        if (widget && widget.firstElementChild)
          widget.firstElementChild.style.position = 'absolute'
      }, 3000)
    }
    return this.hasToggleBackCamera
  }

  /**
   * 切换摄像头具体逻辑
   */
  switchCamera() {

  }

  /**
   * 切换本地摄像头开启/关闭
   */
  toggleLocalCameraMute(successCallback) {
    let ref = this.requireRtcEngine('toggleLocalCameraMute')
    if (ref) {
      let delegate = this
      this.muteLocalVideoStream(!this.hasMuteLocalCamera).then(ret => {
        log(delegate.cName, '关闭本地摄像头  ' + delegate.hasMuteLocalCamera + ' ' + ret)
        if (ret == 0) {
          successCallback && successCallback()
          delegate.hasMuteLocalCamera = !delegate.hasMuteLocalCamera
          if (delegate.eventHandler) {
            delegate.eventHandler.onLocalVideoMuteChange(delegate.hasMuteLocalCamera)
          }

        }
      })
    }
    return this.hasMuteLocalCamera
  }

  async muteLocalVideoStream(isMute) {
    let res = -1
    let target = this
    if (this.localTracks.videoTrack) {
      res = await this.localTracks.videoTrack.setEnabled(!isMute).then(() => {
        return 0
      }).catch(e => {
        console.log('muteVideo' + JSON.stringify(e))
        return -1
      })
    }
    return res
  }

  /**
   * 切换本地麦克风开启/关闭
   */
  toggleLocalMicMute(successCallback) {
    let ref = this.requireRtcEngine('toggleLocalMicMute')
    if (ref) {
      let target = this
      this.muteLocalAudioStream(!this.hasMuteLocalMic).then(ret => {
        log(target.cName, '关闭本地麦克风  ' + !target.hasMuteLocalMic + ' ' + ret)
        if (ret == 0) {
          successCallback && successCallback()
          if (target.eventHandler) {
            target.eventHandler.onLocalAudioMuteChange(target.hasMuteLocalMic)
          }
        }
      })

    }
    return this.hasMuteLocalMic
  }

  async muteLocalAudioStream(isMute) {
    let res = -2
    let target = this
    if (this.localTracks.audioTrack) {
      res = await this.localTracks.audioTrack.setEnabled(!isMute).then(() => {
        target.hasMuteLocalMic = isMute
        return 0
      }).catch(e => {
        return -1
      })
    }
    return res
  }

  /**
   * 双方的视频是否渲染
   */
  isRenderSuccess() {
    return this.localTracks.videoTrack != null && this.remoteUsers != null
  }

  isRenderSelf() {
    return this.localTracks.videoTrack != null
  }

  async subscribe(user, mediaType, $) {
    if (this.mRtcClient == null) {
      return
    }
    const uid = user.uid
    // subscribe to a remote user
    if (mediaType === 'video') {
      this.pageTarget.remoteList.push({
        id: uid
      })
    }
    if (!this.eventHandler.canPlayRemote(uid)) {
      return
    }
    let target = this.pageTarget
    let self = this
    await this.mRtcClient.subscribe(user, mediaType).catch(e => {
      hideDialog(target)
    })
    console.log('subscribe success')
    if (mediaType === 'video') {

      hideDialog(target)
      if (user.videoTrack) {
        target.$nextTick(() => {
          try {
            $('#player-' + uid).empty()
            $('#player-' + uid).hide()
          } catch (e) {
            console.log('no element:#' + uid)
          }
          user.videoTrack.on('video-element-visible-status', status => {
            target.eventHandler && target.eventHandler.onRemoteVideoElementVisibleChanged && target.eventHandler.onRemoteVideoElementVisibleChanged(uid, status.visible)
          })
          user.videoTrack.on('first-frame-decoded', () => {
            $('#player-' + uid).show()
          })
          user.videoTrack.play('player-' + uid, {fit: 'cover'})
        })

      }
    }
    if (mediaType === 'audio') {
      user.audioTrack.play()
    }
  }

  handleUserPublished(user, mediaType, target, $) {
    const id = user.uid
    target.remoteUsers[id] = user
    target.subscribe(user, mediaType, $)
  }

  handleUserUnpublished(user, target, mediaType) {
    const id = user.uid
    delete target.remoteUsers[id]
    if (!isnull(this.mRtcClient)) {
      this.mRtcClient.unsubscribe(user, mediaType)
    }
  }

  /**
   * 设置本地/远端的视频
   */
  putOnVideo(uid) {
    let ref = this.requireRtcEngine('putOnVideo')
    if (ref) {
      log(this.cName, 'putOnVideo-- 设置本地/远端的视频  uid = ' + uid)

      if (this.eventHandler && this.eventHandler.getVideoContainer(uid)) {
        let container = this.eventHandler.getVideoContainer(uid)
        if (container.childCount != 0) {
          loge(this.cName, 'putOnVideo-- 视频容器有填充视频view，执行遍历检查')
          let findSelfVideo = false
          let it = container.children.iterator
          while (it.hasNext()) {
            let tmp = it.next()
            if (tmp.tag != uid) {
              it.remove()
              loge(this.cName, 'putOnVideo-- 视频容器已经设置视频，并且不是自己，移除')
            } else {
              findSelfVideo = true
              loge(this.cName, 'putOnVideo-- 视频容器已经设置视频，是自己')
            }
          }
          if (findSelfVideo) {
            loge(this.cName, 'putOnVideo-- 视频容器已经设置视频，跳过')
            return
          }
        }
        let videoSurface = RtcEngine.CreateRendererView(TopApplication.instance)
        if (uid == global.getUser().accountId) {
          // let ret = setupLocalVideo(VideoCanvas(videoSurface, VideoCanvas.RENDER_MODE_HIDDEN, uid))
          log(this.cName, '设置本地视频  ' + ret)
        } else {
          // let ret = setupRemoteVideo(VideoCanvas(videoSurface, VideoCanvas.RENDER_MODE_HIDDEN, uid))
          log(this.cName, '设置远端视频  ' + ret)
          /**
           * 2021.3.19改，去掉接收远端是否镜像处理，交由发送端处理
           */
          // 设置开启镜像模式，默认关闭。将视频发送方和接收方的视频方向设置一样
//                    setRemoteRenderMode(uid, VideoCanvas.RENDER_MODE_HIDDEN, Constants.VIDEO_MIRROR_MODE_ENABLED)
        }
        // 绑定uid，判断是否重复添加，以及是否需要移除无用视频
        videoSurface.tag = uid

        container.addView(videoSurface)
        onRenderViewCreate(uid, videoSurface)

        removeVideoContainerRef(container)
        videoContainerListRef.add(WeakReference(container))

        return
      }

      loge(this.cName, '设置本地/远端的视频 没有找到 uid = $uid 的视频容器，是否设置eventHandler = ${eventHandler != null}')
    }
  }

  /**
   * 关闭本地/远端视频
   */
  putDownVideo(uid) {
    log(this.cName, '关闭本地/远端视频  uid ' + uid)
    if (this.eventHandler && this.eventHandler.getVideoContainer(uid)) {
      let container = this.eventHandler.getVideoContainer(uid)
      // container.removeAllViews()
      this.removeVideoContainerRef(container)

    }
    if (this.mRtcClient) {
      if (uid == global.getUser().accountId) {
        // this.mRtcClient.setupLocalVideo(VideoCanvas(null, VideoCanvas.RENDER_MODE_HIDDEN, uid))
      } else {
        // this.mRtcClient.setupRemoteVideo(VideoCanvas(null, VideoCanvas.RENDER_MODE_HIDDEN, uid))
      }
    }
  }

  removeVideoContainerRef(container) {
    for (let i = 0; i < this.videoContainerListRef.length; i++) {
      // if (videoContainerListRef[index].get() == container) {
      //   videoContainerListRef.removeAt(index)
      //   return
      // }
    }

  }

  /**
   * 开启本地视频流
   */
  putOnLocalVideo() {
    this.putOnVideo(global.getUserId())
  }

  /**
   * 关闭本地视频流
   */
  putDownLocalVideo() {
    this.putDownVideo(global.getUserId())
  }

  /**
   * 上麦
   */
  setBroadcast() {
    let ref = this.requireRtcEngine('setBroadcast')
    if (ref) {
      // this.resetLocalValue()
      ref.setClientRole(ClientRole.CLIENT_ROLE_BROADCASTER)
      // this.putOnLocalVideo()
    }

  }

  /**
   * 下麦
   */
  setAudience() {
    let ref = this.requireRtcEngine('setAudience')
    if (ref) {
      // this.resetLocalValue()
      ref.setClientRole(ClientRole.CLIENT_ROLE_AUDIENCE)
      // this.putDownLocalVideo()

      // this.resetLocalValue()
    }
  }

  /**
   * 离开频道
   */
  async leaveChannel() {

    let ref = this.requireRtcEngine('leaveChannel')
    if (ref) {
      this.eventHandler = null
      // let ret = leaveChannel()
      // log-=
      this.resetLocalValue()
      this.hasPublishVideo = false
      this.hasPublishAudio = false
      if (this.mRtcClient) {
        await this.mRtcClient.leave()
        this.mRtcClient = null
      }
      console.log('client leaves channel success')
    }

    // remove remote users and player views
    this.remoteUsers = {}
    // for (let videoContainerListRefElement of this.videoContainerListRef) {
    //   // it.get()?.removeAllViews()
    //   // it.clear()
    // }
    this.videoContainerListRef = []
    this.unpublishLocal(true)
  }

  /**
   * 销毁engine实例
   */
  async releaseEngine() {
    log(this.cName, '销毁engine实例')
    this.leaveChannel()

  }

  /**
   * 重制本地的状态
   */
  resetLocalValue() {
    if (this.hasToggleBackCamera) {
      this.toggleCamera()
    }
    // if (this.mRtcClient) {
    //   this.mRtcClient.muteLocalAudioStream(false)
    //   this.mRtcClient.muteLocalVideoStream(false)
    // }

    this.hasToggleBackCamera = false
    this.hasMuteLocalCamera = false
    this.hasMuteLocalMic = false
  }

  /**
   * 渲染视频view创建成功
   */
  onRenderViewCreate(uid, renderView) {
  }

  /*****************************声网事件回调******************************/

  /**
   * 通信场景，表示有人加入频道
   * 直播场景，表示有人上麦
   * 新加入的用户也能收到已经在的用户的回调
   */
  onUserJoined(uid, elapsed) {
    log(this.cName, 'onUserJoined --------  uid = ${uid}')
    if (this.eventHandler) {
      this.eventHandler.onUserJoined(uid)
    }

  }

  /**
   * 加入频道回调
   */
  onJoinChannelSuccess(channel, uid, elapsed) {
    log(this.cName, '加入频道回调 onJoinChannelSuccess  channel = $channel  uid = $uid')
    if (this.eventHandler) {
      this.eventHandler.onJoinChannelSuccess(channel, uid)
    }
  }

  /**
   * 远端音频状态发生改变回调
   */
  onRemoteAudioStateChanged(uid, state, reason, elapsed) {
    log(this.cName, '远端音频状态发生改变回调 onRemoteAudioStateChanged  uid = $uid    state = $state    reason = $reason')
    if (this.eventHandler) {
      if (state == RemoteAudioState.REMOTE_AUDIO_STATE_STOPPED && reason == RemoteAudioReason.REMOTE_AUDIO_REASON_REMOTE_MUTED) {
        this.eventHandler.onRemoteAudioMuteChange(uid, true)
      } else if (state == RemoteAudioState.REMOTE_AUDIO_STATE_DECODING && reason == RemoteAudioReason.REMOTE_AUDIO_REASON_REMOTE_UNMUTED) {
        this.eventHandler.onRemoteAudioMuteChange(uid, false)
      }
    }
  }

  /**
   * 远端用户视频状态发生改变回调
   */
  onRemoteVideoStateChanged(uid, state, reason, elapsed) {
    log(this.cName, '远端用户视频状态发生改变回调 onRemoteVideoStateChanged  uid = $uid    state = $state    reason = $reason')
    if (this.eventHandler) {
      if (reason == RemoteVideoReason.REMOTE_VIDEO_STATE_REASON_REMOTE_UNMUTED) { // 6
        this.eventHandler.onRemoteVideoMuteChange(uid, false)
      } else if (reason == RemoteVideoReason.REMOTE_VIDEO_STATE_REASON_REMOTE_MUTED) { // 5
        this.eventHandler.onRemoteVideoMuteChange(uid, true)
      } else if (state == 2 && reason == RemoteVideoReason.REMOTE_VIDEO_STATE_REASON_LOCAL_UNMUTED) { // 4
        this.eventHandler.onUserJoined(uid)
      } else if (reason == RemoteVideoReason.REMOTE_VIDEO_STATE_REASON_REMOTE_OFFLINE) { // 7
        this.eventHandler.onRemoteVideoMuteChange(uid, true)
      }
    }
  }

  /**
   * 已显示本地视频首帧回调
   */
  onFirstRemoteVideoFrame(uid, width, height, elapsed) {
    log(this.cName, '已显示远端视频首帧回调 uid = $uid')
    if (this.eventHandler) {
      this.eventHandler.onRemoteVideoMuteChange(uid, false)
    }
  }

  /**
   * 已显示本地视频首帧回调
   */
  onFirstLocalVideoFrame(width, height, elapsed) {
    log(this.cName, '已显示本地视频首帧回调')
    if (this.eventHandler) {
      this.eventHandler.onLocalVideoMuteChange(false)
    }
  }

  /**
   * 用户音量变化回调
   *  onAudioVolumeIndication(speakers: Array<out AudioVolumeInfo>?, totalVolume: Int)
   */
  onAudioVolumeIndication(speakers, totalVolume) {
    if (this.eventHandler) {
      this.eventHandler.onAudioVolumeIndication(speakers, totalVolume)
    }

  }

  onUserOffline(uid, reason) {
    log(this.cName, 'onUserOffline-- uid=$uid    reason=$reason')
    if (this.eventHandler) {
      this.eventHandler.onUserOffline(uid)
    }
  }
}



// WEBPACK FOOTER //
// ./src/rtc/TopRtcDelegate.js